import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sensors-types',
  templateUrl: './sensors-types.component.html',
  styleUrls: ['./sensors-types.component.scss'],
})
export class SensorsTypesComponent implements OnInit {
  constructor() { }

  ngOnInit(): void {
  }
}
